module.exports = __webpack_public_path__ + "static/media/ZALORA.51c0429a.svg";